// Copyright Abridged, Inc. 2021,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - User
 * User
 */
@model({name: 'User'})
export class User {
  constructor(data?: Partial<User>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  id?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  createdTime?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  pk?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  sk?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifier?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifierGroup?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  platform?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  userName?: string;
}

export interface UserRelations {
  // describe navigational properties here
}

export type UserWithRelations = User & UserRelations;
